<div class="tabs flex flex-row gap-[8px] justify-start items-center">
  <app-extended-parameters-tab
    [title]="'DIAGNOSTICS.EXTENDED_PARAMETERS_TAB.SEARCHED_PARAMETERS' | translate"
    [extendedParametersTab]="extendedParametersTabsEnum.SearchedParameters"
    [gatewaySerial]="gatewaySerial"
    data-at-searched-parameters-tab
  ></app-extended-parameters-tab>

  <app-extended-parameters-tab
    *ngIf="remoteDiagnosticsUseCasesStore.useCases$ | async"
    [title]="'DIAGNOSTICS.EXTENDED_PARAMETERS_TAB.USE_CASES' | translate"
    [extendedParametersTab]="extendedParametersTabsEnum.UseCases"
    [gatewaySerial]="gatewaySerial"
    data-at-use-cases-tab
  ></app-extended-parameters-tab>
</div>
